import React, { useState } from 'react';
import { formatStringDate } from '../../../helpers/dateFormatter'
import ApartmentTenantService from '../../../services/ApartmentTenantService';
import EditApartmentTenantComponent from './EditApartmentTenantComponent';

function ApartmentTenantMoreInfoComponent(props) {
    const [edit, setEdit] = useState(false);

    const splitNumber = (number) => {
        if (!!number) {
            var newNumber = number.replace(/\D/g, '');
            return newNumber.replace(/(.{2})/g, '$1 ').trim();
        }
        return '';
    };

    const toggleEdit = () => {
        setEdit(!edit);
    };

    const deleteTenant = () => {
        if(window.confirm("Vil du slette " + props.apartmentTenant.tenant.firstname + " " + props.apartmentTenant.tenant.lastname+ " fra denne bolig?")){
            ApartmentTenantService.deleteApartmentTenant(props.apartmentTenant, props.apartment);
        }
    };

    var phone = splitNumber(props.apartmentTenant.tenant.phone);

    return <React.Fragment>{!edit ? <div className={"row mb-2 " + props.warning}>
        <div className="col">
            <div className="row">
                <div className="col">
                    <label><b>Navn</b></label><br />
                    {props.apartmentTenant && props.apartmentTenant.tenant.firstname} {props.apartmentTenant && props.apartmentTenant.tenant.lastname}
                </div>
                <div className="col">
                    <label><b>Telefon</b></label><br />
                    {props.apartmentTenant && phone}
                </div>
                <div className="col">
                    <label><b>Email</b></label><br />
                    {props.apartmentTenant != null ? <a href={"mailto:" + (props.apartmentTenant.tenant.email != null ? props.apartmentTenant.tenant.email : "no@email.com") + "?Subject=Kontakt"} target="_top">{props.apartmentTenant && props.apartmentTenant.tenant.email}</a> : ""}
                </div>
                <div className="col">
                    <label><b>Indflytningdato</b></label><br />
                    {props.apartmentTenant && formatStringDate(props.apartmentTenant.seniority_date)}
                </div>
                <div className="col">
                    <label><b>Seneste flytning</b></label><br />
                    {props.apartmentTenant && formatStringDate(props.apartmentTenant.seniority_date2)}
                </div>
            </div>
            <div className="row">
                <div className="col-2">
                    <button className="btn btn-primary" onClick={() => toggleEdit()}>Rediger beboer</button>
                </div>
                <div className="col-2">
                    <button className="btn btn-primary" onClick={() => deleteTenant()}>Slet beboer</button>
                </div>
            </div>
        </div>
    </div> : <EditApartmentTenantComponent apartment={props.apartment} apartmentTenant={props.apartmentTenant} toggleEdit={toggleEdit}></EditApartmentTenantComponent>}
    </React.Fragment>;
}
export default ApartmentTenantMoreInfoComponent;